import {style, keyframes} from 'typestyle'
import * as csstips from 'csstips'

export const FreeLecture = style({
    paddingTop: 8,
    paddingBottom: 50
})

export const main = style({
    width: '100%',
    height: '100%',
    maxWidth: '480px',
    minWidth: '320px',
    minHeight: '100%',
    position: 'relative',
    fontFamily: 'PingFangSC-Regular'
})

export const freeLectureListWrap = style({
    minHeight: '100vh',
    paddingBottom: 1,
    position: 'relative'
})

export const topBanner = style({
    width: '100%',
    cursor: 'pointer'
})

export const bannerImg = style({
    position: 'relative',
    width: '100%'
})

export const NoSubscribeImg = style({
    height: 'auto'
})

const breathe = keyframes({
    // '0%': {transform: 'scale(1.05)'},
    // '50%': {transform: 'scale(1.025)'},
    // '100%': {transform: 'scale(1)'}
    from: {transform: 'scale(1.05)'},
    to: {transform: 'scale(1)'}
})

export const topBannerButton = style({
    position: 'absolute',
    bottom: 9,
    left: '50%',
    transform: 'translate(-50%, 0)'
})

export const topBannerButtonText = style({
    'width': '53.33vw',
    'maxWidth': '256px',
    'height': 44,
    'borderRadius': 44,
    // 'background': '#FFAE14',
    'background': 'linear-gradient(180deg, #FFF72D, #FFAE14)',
    '-webkit-animation-timing-function': 'cubic-bezier(0.25,0.1,0.25,1)',
    '-webkit-animation-name': breathe,
    '-webkit-animation-duration': '500ms',
    '-webkit-animation-iteration-count': 'infinite',
    '-webkit-animation-direction': 'alternate',
    ...csstips.flexRoot,
    ...csstips.centerJustified,
    ...csstips.center,
    'color': '#D31900',
    'fontSize': 20,
    'fontWeight': 600,
    'boxShadow': '0 3px 8px 0 rgba(255,156,0,0.50)'
})

export const freeLectureListBox = style({
    ...csstips.flexRoot,
    ...csstips.centerJustified,
    ...csstips.center,
    height: '100%',
    width: '100%',
    cursor: 'pointer'
})

export const freeLectureListItem = style({
    width: '100%',
    padding: '15px',
    backgroundColor: '#fff',
    ...csstips.flexRoot,
    ...csstips.centerJustified,
    ...csstips.center,
    WebkitBoxOrient: 'horizontal',
    WebkitBoxDirection: 'normal',
    flexDirection: 'row',
    position: 'relative',
    overflow: 'hidden',
    maxHeight: 120,
    $nest: {
        '&::before': {
            'content': `""`,
            'position': 'absolute',
            'top': 0,
            'width': 'calc(100vw - 10px)',
            'max-width': '470px',
            'border-top': '0 solid #f0f0f0',
            'transform-origin': '100% 0',
            'transform': 'scaleY(.5)'
        }
    }
})

export const currentItemLeftBox = style({
    ...csstips.flexRoot,
    ...csstips.startJustified,
    ...csstips.center,
    ...csstips.vertical,
    height: 90
    // $nest: {
    //     '@media (max-width: 330px)': {
    //         height: 78
    //     }
    // }
})

export const currentItemLeft = style({
    marginRight: 10,
    width: 120,
    height: 68,
    position: 'relative',
    borderTopLeftRadius: 4,
    borderTopRightRadius: 4,
    backgroundPosition: 'center center',
    backgroundSize: 'cover',
    backgroundRepeat: 'no-repeat'
})

export const currentItemImg = style({
    // width: 119,
    // height: 68,
    // position: 'relative',
    // overflow: 'hidden',
    // borderRadius: '4px 4px 0 0',
    // $nest: {
    //     '@media (max-width: 330px)': {
    //         width: 90,
    //         height: 56
    //     }
    // }
    width: 120,
    height: 68,
    position: 'relative',
    overflow: 'hidden',
    borderTopLeftRadius: 4,
    borderTopRightRadius: 4,
    backgroundPosition: 'center center',
    backgroundSize: 'cover',
    backgroundRepeat: 'no-repeat'
})

export const currentItemRight = style({
    width: 'calc(100% - 130px)',
    ...csstips.flexRoot,
    ...csstips.startJustified,
    ...csstips.start,
    WebkitBoxOrient: 'vertical',
    WebkitBoxDirection: 'normal',
    WebkitBoxPack: 'justify',
    height: 90
    // $nest: {
    //     '@media (max-width: 330px)': {
    //         width: 'calc(100% - 100px)',
    //         height: 78
    //     }
    // }
})

export const currentItemRightTitle = style({
    'fontSize': 16,
    'color': '#333333',
    'textOverflow': 'ellipsis',
    'display': '-webkit-box',
    '-webkit-line-clamp': 2,
    'WebkitBoxOrient': 'vertical',
    'fontWeight': 600,
    'overflow': 'hidden',
    'lineHeight': '22px'
})

export const currentItemRightContainer = style({
    ...csstips.flexRoot,
    ...csstips.centerJustified,
    ...csstips.center,
    margin: 0,
    padding: 0,
    position: 'absolute',
    width: '32vw',
    maxWidth: 120,
    height: 36,
    backgroundColor: '#FF5A31',
    borderRadius: 36,
    top: 69,
    right: 15,
    fontSize: 16,
    boxShadow: '0 5px 10px 0 rgba(255,90,49,0.30)',
    cursor: 'pointer',
    $nest: {
        '&:active': {
            backgroundColor: '#E4431B'
        }
    }
})

export const currentItemRightMiddle = style({
    lineHeight: 1,
    color: '#ffffff',
    marginBottom: 10
})

export const currentItemRightBottom = style({
    ...csstips.flexRoot,
    ...csstips.centerJustified,
    ...csstips.center,
    fontSize: 16,
    color: '#ffffff',
    fontWeight: 600,
    letterSpacing: 1
})

export const currentItemRightBottomLeftContent = style({
    width: 120,
    height: 22,
    ...csstips.flexRoot,
    ...csstips.center,
    ...csstips.centerJustified,
    position: 'relative',
    background: '#F4F4F4',
    borderBottomLeftRadius: 4,
    borderBottomRightRadius: 4,
    fontSize: 12,
    color: '#999999',
    letterSpacing: 0,
    lineHeight: '12px',
    $nest: {
        '& img': {
            width: 10,
            marginRight: 5
        }
    }
})

export const studyNum = style({
    ...csstips.flexRoot,
    ...csstips.center,
    ...csstips.centerJustified,
    marginLeft: 1
})



// WEBPACK FOOTER //
// ./src/views/FreeLecture/components/FreeLectureLise/FreeLectureList.style.ts